var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      model: {
        value: _vm.valid,
        callback: function($$v) {
          _vm.valid = $$v
        },
        expression: "valid"
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "mt-4", attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                staticClass: "px-1",
                attrs: {
                  counter: 128,
                  rules: [
                    _vm.vr.primitives.required,
                    _vm.vr.primitives.maxLength(128)
                  ],
                  label: _vm.$t("Name"),
                  outlined: ""
                },
                model: {
                  value: _vm.model.itemName,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "itemName", $$v)
                  },
                  expression: "model.itemName"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("v-select", {
                staticClass: "px-1",
                attrs: {
                  items: _vm.availableCurrencies,
                  "item-text": "description",
                  "item-value": "code",
                  required: "",
                  label: _vm.$t("Currency"),
                  outlined: ""
                },
                model: {
                  value: _vm.model.currency,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "currency", $$v)
                  },
                  expression: "model.currency"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("v-text-field", {
                staticClass: "px-1",
                attrs: {
                  label: _vm.$t("Price"),
                  rules: [
                    _vm.vr.primitives.biggerThan(0),
                    _vm.vr.primitives.precision(2)
                  ],
                  required: "",
                  outlined: ""
                },
                model: {
                  value: _vm.model.price,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "price", $$v)
                  },
                  expression: "model.price"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("v-text-field", {
                staticClass: "px-1",
                attrs: {
                  counter: 50,
                  rules: [_vm.vr.primitives.maxLength(50)],
                  label: _vm.$t("ExternalReference"),
                  outlined: ""
                },
                model: {
                  value: _vm.model.externalReference,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "externalReference", $$v)
                  },
                  expression: "model.externalReference"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", md: "6" } },
            [
              _c("v-text-field", {
                staticClass: "px-1",
                attrs: {
                  counter: 50,
                  rules: [_vm.vr.primitives.maxLength(50)],
                  label: _vm.$t("WoocommerceID"),
                  outlined: ""
                },
                model: {
                  value: _vm.model.woocommerceID,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "woocommerceID", $$v)
                  },
                  expression: "model.woocommerceID"
                }
              })
            ],
            1
          ),
          !_vm.$vuetify.breakpoint.smAndDown
            ? _c(
                "v-col",
                { staticClass: "d-flex justify-end", attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { color: "white", to: _vm.cancelRoute },
                      on: {
                        click: function($event) {
                          return _vm.$emit("cancel")
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.ok()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Save")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$vuetify.breakpoint.smAndDown
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { block: "", color: "white", to: _vm.cancelRoute },
                      on: {
                        click: function($event) {
                          return _vm.$emit("cancel")
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Cancel")))]
                  ),
                  _c("v-spacer", { staticClass: "py-2" }),
                  _c(
                    "v-btn",
                    {
                      attrs: { block: "", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.ok()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Save")))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }